// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Iframe_iframe__hyLKP","urlPreview":"Iframe_urlPreview__GnijD","iframeError":"Iframe_iframeError__hJEKh"};